import React from 'react';

type MiniButtonProps = {
  label: string;
  onClick: () => void;
  ariaLabel?: string;
  title?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  /** Optional fill/background color */
  fillColor?: string;
  /** Optional border/outline color */
  outlineColor?: string;
  /** Optional text color override */
  textColor?: string;
  /** Optional hover fill override */
  hoverFillColor?: string;
  /** Optional hover border override */
  hoverOutlineColor?: string;
  /** Optional hover text override */
  hoverTextColor?: string;
};

/**
 * MiniButton - compact inline button matching the "Friends to visit" delete style.
 * Color customizations are optional; defaults provide a neutral appearance.
 */
const MiniButton: React.FC<MiniButtonProps> = ({
  label,
  onClick,
  ariaLabel,
  title,
  className,
  type = 'button',
  disabled,
  fillColor,
  outlineColor,
  textColor,
  hoverFillColor,
  hoverOutlineColor,
  hoverTextColor
}) => {
  type MiniStyle = React.CSSProperties & Record<string, string>;
  const style: MiniStyle = {};

  if (fillColor) style['--mini-fill'] = fillColor;
  if (outlineColor) style['--mini-border'] = outlineColor;
  if (textColor) style['--mini-text'] = textColor;
  if (hoverFillColor) style['--mini-hover-fill'] = hoverFillColor;
  if (hoverOutlineColor) style['--mini-hover-border'] = hoverOutlineColor;
  if (hoverTextColor) style['--mini-hover-text'] = hoverTextColor;

  return (
    <button
      type={type}
      aria-label={ariaLabel || title || label}
      title={title}
      onClick={onClick}
      disabled={disabled}
      className={`mini-button ${className ?? ''}`.trim()}
      style={style}
    >
      {label}
    </button>
  );
};

export default MiniButton;

